$shm_hitalama_map_widget_float_text $shm_hitalama_map_widget_float
	controls /
		<= Text $mol_textarea
			value? <=> text? \
			selection? <=> selection? /number
			spellcheck false
			focused => text_focused
			style *
				color <= color
				fontSize <= font_size_px
				height <= textarea_height \100%
				position <= textarea_position \absolute
		^ blocker / <= Blocker $mol_view
			style *
				transform <= blocker_transform \
			event *
				pointerdown? <=> blocker_pointerdown? null
				pointerup? <=> blocker_pointerup? null
			attr *
				is_button <= is_button true
		^ image / <= Image $mol_image
			uri <= image_uri \
	settings_content /
		<= Link_to_viewport_label $mol_paragraph
			title \Ссылка на viewport
		<= Link_to_viewport $mol_string
			value? <=> viewport_id? \
			hint <= link_to_viewport_hint \
	Tools $shm_hitalama_map_widget_tools
		widget <= widget
		Map_page <= Map_page
		settings_content <= settings_content
		settings_tool_visible => settings_tool_visible
		settings_bubble_content => settings_bubble_content
		Up => Up
		Down => Down
		Copy_code => Copy_code
		Auto_height => Auto_height
		Lock => Lock
		Fullscreen => Fullscreen
		Delete => Delete
		sub /
			^ tools_custom
			<= Up
			<= Down
			<= Copy_code
			<= Auto_height
			<= Lock
			<= Fullscreen
			<= Delete
	tools_custom /
		^ font_tools /
			<= Color $shm_hitalama_color_pick
				color? <=> color? \var(--mol_theme_text)
				color_default \var(--mol_theme_text)
				hint @ \Font color
			<= Font_size_tool $shm_hitalama_map_fontsize
				font_size? <=> font_size? 14
